// JsFromRoutes CacheKey d967750a25317ea572141111e93a3333
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  submit: /* #__PURE__ */ definePathHelper('post', '/test/submit'),
  show: /* #__PURE__ */ definePathHelper('get', '/test'),
}
